import {Grid, LinkButton, Logo as LogoBase} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import clsx from 'clsx'
import React from 'react'

import {config, isMarketIntegration} from 'src/shared/config'

import {useMarginRef} from '../margin-provider'
import {additionalClasses, classes} from './styles'
import {Variant} from './types'

type Props = {
  variant?: Variant
}

const Header: React.FC<Props> = ({variant}) => {
  const t = useI18n()
  const brand = config.brand
  const ref = useMarginRef<HTMLDivElement>(el => ({
    top: el.clientHeight,
  }))

  return (
    <Grid
      ref={ref}
      alignItems="center"
      className={clsx(
        classes.root,
        variant && classes[`variant_${variant}`],
        isMarketIntegration && additionalClasses.isYandexIntegration,
      )}
      container
    >
      {isMarketIntegration ? (
        <LogoBase brand={brand} component="div" lang={config.lang} />
      ) : (
        <LogoBase brand={brand} component="a" href="/" lang={config.lang} />
      )}
      {brand !== 'yango' && !isMarketIntegration && (
        <LinkButton className={classes.button} href="/" size="s">
          {t('route_delivery_for_business', 'Доставка для бизнеса')}
        </LinkButton>
      )}
    </Grid>
  )
}

export default Header
